<template>
    <div class="page404">
        <v-layout row justify-center>
            <v-flex xs12 md6 lg4>
                <v-card>
                    <v-card-title class="headline font-weight-medium error white--text">
                        <span>404: NOT FOUND</span>
                        <v-spacer></v-spacer>
                        <v-icon large dark>error_outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-layout align-center justify-space-between column fill-height>
                            <v-flex>
                                <p class="text-xs-center subheading font-weight-medium error--text">Запрошенной страницы
                                    не
                                    существует.</p>
                            </v-flex>
                            <v-flex align-center>
                                <img src="/content/404cat.gif" width="100%" />
                            </v-flex>
                            <v-flex>
                                <v-btn class="primary" dark large to="/">
                                    <v-icon left>home</v-icon>
                                    <span>На главную</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: "PageNotFound"
    }
</script>

<style scoped>

</style>